import React from "react";
import PokemonDetails from "./PokemonDetails";

interface PokemonCardButtonProps {
  isRevealed: boolean;
  imageUrl: string;
  name: string;
  onClickHandler: Function;
  index: number;
  isRevealingTwoCards: boolean;
  isMatched: boolean;
}

const PokemonCardButton = ({
  isRevealed,
  imageUrl,
  name,
  onClickHandler,
  index,
  isRevealingTwoCards,
  isMatched,
}: PokemonCardButtonProps) => {
  return (
    <button
      className={`border-2 rounded-lg transition-all ${
        isMatched 
          ? "bg-green-500 border-green-600" 
          : "bg-white border-gray-300 hover:border-purple-400 hover:shadow-lg"
      } ${isRevealed ? "" : "cursor-pointer"}`}
      onClick={() => {
        if (!isRevealingTwoCards) {
          onClickHandler(index);
        }
      }}
      disabled={isRevealed}
    >
      <PokemonDetails name={name} imageUrl={imageUrl} isRevealed={isRevealed} />
    </button>
  );
};

export default PokemonCardButton;
